




































import { Cirus } from '@/classes/Http';
import { GetInstanceResponse, InstanceCategory } from '@/classes/TayehApi/Instance';
import { UserShop } from '@/classes/TayehApi/User';
import date from '@/mixins/date';
import {Component, Prop, Vue} from 'vue-property-decorator';
import { mapGetters } from 'vuex';
@Component({
	filters: {
		date
	},
	computed: {
		...mapGetters(['USER_TOKEN'])
	}
})
export default class DashboardShopsCard extends Vue {
	@Prop() instance: UserShop;
	@Prop() getinstances: () => GetInstanceResponse;
	@Prop() primary: boolean;
	@Prop() category: 'company'|'shop'|'service';

	async setPrimary() {
		let user = await this.$store.getters.USER;
		if (!user) return;
		try {	
			await Cirus.post(
			`/user/update`,
			{id: user.id, primary_instance_id: this.instance.id}
		)
		if (typeof this.getinstances !== 'undefined') this.getinstances();
		this.$forceUpdate();
		this.$message({
				showClose: true,
				message: `${this.name()} با موفقیت اولویت داده شد.`,
				type: 'success',
				duration: 5000
		});
		} catch {
			this.$message({
				showClose: true,
				message: 'لطفا دوباره تلاش کنید.',
				type: 'error',
				duration: 10000
			});
		}
	}
	name (): string{
		return {company: 'شرکت', shop: 'فروشگاه', service: 'خدماتی'}[this.category] || 'کسب و کار';
	}
	link (): string{
		return {company: 'companies', shop: 'shops', service: 'services'}[this.category] || 'customs';
	}
}
